<section class="mt-2 grid gap-2">
  <h2 class="m-0 text-xl font-semibold leading-tight text-text">Navigate using Topics</h2>
  <hr class="mb-3 border-0 border-t border-subtle" />

  @if (vm$ | async; as vm) {
    @if (vm.isLoading) {
      <p class="text-sm text-text-muted">Loading topics...</p>
    } @else if (vm.hasError) {
      <p class="text-sm text-text-muted">Topics are unavailable right now. Please try again.</p>
    } @else if (vm.isEmpty) {
      <p class="text-sm text-text-muted">No topics are available right now.</p>
    } @else {
      <div class="grid grid-cols-1 gap-5 sm:grid-cols-2 xl:grid-cols-4">
        @for (topic of vm.topics; track topic._id) {
          <article
            class="flex h-52 flex-col overflow-hidden rounded-lg bg-white p-4 shadow-xl shadow-black/30 ring-1 ring-black/10"
          >
            <div class="flex items-start gap-4">
              <a [href]="topicHref(topic._id)" class="shrink-0">
                <img [src]="topic.assetPath" [alt]="topic.topic" class="w-20" />
              </a>

              <div class="min-w-0">
                <h5 class="m-0 mb-1">
                  <a
                    [href]="topicHref(topic._id)"
                    class="text-xl font-bold text-secondary no-underline"
                  >
                    <small class="text-lg font-bold leading-5 text-secondary no-underline">{{
                      topic.topic
                    }}</small>
                  </a>
                </h5>
                <span
                  class="inline-flex rounded-lg bg-primary px-2 py-1 text-xs font-semibold text-primary-contrast"
                  >{{ topic.numeronCount }}</span
                >
              </div>
            </div>

            <div class="mt-4 min-h-0 flex-1 overflow-hidden">
              <div class="text-sm leading-5">
                @for (category of topic.categories | slice: 0 : 5; track category) {
                  <a
                    [href]="categoryHref(category)"
                    class="mb-1 mr-1 inline-block align-top whitespace-normal break-keep text-sm text-secondary no-underline"
                    >{{ category }}</a
                  >
                }
              </div>
            </div>
          </article>
        }
      </div>
    }
  }
</section>
